export const storeIds = [
  { value: 'a0dUd000006MKmE', label: "Sam's Club Gaithersburg, Maryland" },
  { value: 'a0dUd000006MBnq', label: "Sam's Club Washington, Pennsylvania" },
];
